import angular from 'angular';
import templateUrl from './app.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@',
    currentUser: '<'
  },
  controller: class AppComponent {
    constructor($mdDialog, $mdMedia, $mdSidenav,
      $state, $scope, AuthService,
      FeedbackService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $mdMedia,
        $mdSidenav,
        $state,
        $scope,
        AuthService,
        FeedbackService,
        ToastService
      });
    }

    $onInit() {
      this.showHamburgerMenu = {
        value: !this.$mdMedia('gt-md')
      };
    }

    logout() {
      return this.authService
        .logout()
        .then(() => this.$state.go('login'));
    }

    addFeedback() {
      const scope = angular.extend(this.$scope.$new(true), {
        onFeedbackSubmitted: $event => this.onFeedbackSubmitted($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        scope,
        fullscreen: true,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <feedback
                on-feedback-submitted="onFeedbackSubmitted($event)">
              </feedback>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onFeedbackSubmitted($event) {
      if ($event && $event.feedback) {
        this.FeedbackService.submit($event.feedback)
          .then(() => {
            this.$mdDialog.hide();
            this.ToastService.showSuccess('Feedback submitted successfully!');
          }).catch(error => this.ToastService.showError(error));
      }
    }

    toggleMenu() {
      this.$mdSidenav('left').toggle();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/app.component.js